export const CL_OPTIONS = ['L', 'R'] as const;

export function getClOptions(
  currentValue: string | null | undefined,
): string[] {
  if (currentValue && !CL_OPTIONS.includes(currentValue as 'L' | 'R')) {
    return [...CL_OPTIONS, currentValue];
  }
  return [...CL_OPTIONS];
}
